import React, { useEffect } from 'react';
import { connect } from 'react-redux';

const GenericGuideContents = (props) => {

    useEffect(() => {

    }, []);

    return (
        <div className='generic-guide-contents'>
            
            {
                props.iContent.title?.value && 
                <div className='content-title'> {props.iContent.title?.value} </div>
            }

            <div className='content-list-wrapper'>
                {
                    props.iContent.contentItemList?.value.map((item, index) => {
                        return (
                            <a key={index} className='content-item' href='#' onClick={(e) => handleItemClick(e, item.sectionName)}>
                                {item.linkText}
                            </a>
                        );
                    })
                }
            </div>

        </div>
    );

    function handleItemClick(e, sectionName) {
        e.preventDefault();
        const element = document.getElementById(sectionName);

        let dims = element.getBoundingClientRect();
        const offsetTop = (dims.top - 100) + window.scrollY;
        window.scrollTo({ top: offsetTop, behavior: 'smooth' });
    }

};

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(GenericGuideContents);